import type { ReactNode } from "react";

export function ErrorMessage({ message }: { message: ReactNode }) {
  return message ? (
    <p className="text-danger-foreground mt-2 text-center" role="alert">
      {message}
    </p>
  ) : null;
}
